// extracted by mini-css-extract-plugin
export default {"container":"coinDisplay_container__WgoM5","coinImg":"coinDisplay_coinImg__BN7xu","coinName":"coinDisplay_coinName__KikHU","coinTag":"coinDisplay_coinTag__3nGqw"};